<script>
import {
  adminListAgentadminEditComputed,
  adminListAgentadminEditMethods,
} from '@state/helpers/admin-list-agentadmin-edit'
import cloneDeep from 'lodash/cloneDeep'
import { STATUS_REQUEST, LEVEL_ADMIN, ROLE } from '@/src/utils/constant'
import { request } from '@/src/services'
import editItems from './editItems'

export default {
  page: {
    title: 'Admin List Agent Admin Edit',
    meta: [
      { name: 'description', content: 'The Admin List Agent Admin Edit page.' },
    ],
  },
  data() {
    return {
      items: null,
      agentAdmin: null,
      ROLE: ROLE,
      title: this.$t('pages.editAdminListAgentAdmin'),
    }
  },
  computed: {
    ...adminListAgentadminEditComputed,
    agentAdminComputed() {
      const agentAdmin = cloneDeep(this.getAgentAdmin)
      const data = editItems?.map((field) => {
        if (field.key === 'level') {
          field.value = LEVEL_ADMIN[agentAdmin?.level]
        } else {
          field.value = agentAdmin[field.key]
        }
        if (field.key === 'password' || field.key === 'password_2') {
          if (field.value === undefined) {
            field.value = ''
          }
        }
        return field
      })
      return data
    },
    currentIdUser() {
      const user = this.$store.getters['auth/getCurrentUser']
      return user?.id
    },
    currentLevelUser() {
      const user = this.$store.getters['auth/getCurrentUser']
      return user?.level
    },
    currentAgentCode() {
      const user = this.$store.getters['auth/getCurrentUser']
      return user?.agent.agent_code
    },
    errorServerSideComputed() {
      return this.getErrors
    },
  },
  watch: {
    getStatus() {
      if (this.getStatus === STATUS_REQUEST.SUCCESS) {
        this.resetAgentAdmin()
        this.backToLoginPage()
      }
    },
  },
  created() {
    this.handleGetAgentAdmin()
    const user = this.$store.getters['auth/getCurrentUser']
    this.$router
      .replace({
        query: { agent_code: user?.agent?.agent_code },
      })
      .catch(() => {})
  },
  mounted() {
    this.initItems()
  },
  methods: {
    ...adminListAgentadminEditMethods,
    initItems() {
      this.items = cloneDeep(editItems)
    },
    handleAddNewAdmin() {
      const payload = this.items.reduce((results, item) => {
        if (item.key === 'level') {
          results[item.key] = this.currentLevelUser
        } else {
          results[item.key] = item.value
        }
        return results
      }, {})
      request({
        endpoint: '/cms/admin/edit/',
        payload: {
          ...payload,
          id: this.currentIdUser,
        },
      }).then(() => {
        this.backToLoginPage()
      })
    },
    handleCancel() {
      this.backToListPage()
    },
    backToLoginPage() {
      if (this.currentLevelUser === ROLE.SUPER) {
        this.$router.push({ path: '/panel/login' })
      } else {
        this.$router.push({
          path: `/panel/login?agent_code=${this.currentAgentCode}`,
        })
      }
    },
    backToListPage() {
      this.$router.push({ path: '/panel/agent-list' })
    },
    handleGetAgentAdmin() {
      const payload = { id: this.currentIdUser }
      this.fetchingAgentAdmin(payload).then(() => {
        this.items = this.agentAdminComputed
      })
    },
    isRequiredPassword(key) {
      const field = {
        passwordConfirm: 3,
        password: 2,
      }
      if (this.items[field[key]].value !== '') {
        return true
      }
      return false
    },
    isComfirmedPassword() {
      if (this.items[2].value !== '' && this.items[3].value !== '') {
        return 'password'
      } else {
        return false
      }
    },
  },
}
</script>

<template>
  <BaseAddNewCard
    :errors="errorServerSideComputed"
    type="edit_agent_admin"
    @submit="handleAddNewAdmin"
    @cancel="handleCancel"
  >
    <template v-slot:header>
      <h5 class="card-title">{{ title }}</h5>
    </template>
    <template v-slot>
      <CRow v-for="item in items" :key="item.key">
        <CCol sm="3">
          {{ item.label }}
          <span v-if="item.rules.required" class="text-danger">*</span>
        </CCol>
        <CCol v-if="currentLevelUser === ROLE.SUPER" sm="9">
          <BaseSelect
            v-if="item.as === 'select'"
            :rules="item.rules"
            :name="item.name"
            :vee-name="item.name"
            :options="item.options"
            :value.sync="item.value"
            :disabled="true"
          />

          <BaseInput
            v-if="item.as === 'input' && item.key === 'password'"
            v-model="item.value"
            :rules="{
              password: true,
              required:
                isRequiredPassword('passwordConfirm') && item.value.length <= 0,
            }"
            :name="item.name"
            :vee-name="item.name"
            :type="item.type"
            autocomplete="new-password"
          />
          <BaseInput
            v-if="item.as === 'input' && item.key === 'password_2'"
            v-model="item.value"
            :rules="{
              password: true,
              required:
                isRequiredPassword('password') && item.value.length <= 0,
              confirmed: isComfirmedPassword(),
            }"
            :name="item.name"
            :vee-name="item.name"
            :type="item.type"
            autocomplete="new-password"
          />
          <BaseInput
            v-if="
              item.as === 'input' &&
                item.key !== 'password' &&
                item.key !== 'password_2'
            "
            v-model="item.value"
            :rules="item.rules"
            :name="item.name"
            :vee-name="item.name"
            :type="item.type"
            autocomplete="new-password"
            disabled
          />
        </CCol>
        <CCol v-else sm="9">
          <BaseSelect
            v-if="item.as === 'select'"
            :rules="item.rules"
            :name="item.name"
            :vee-name="item.name"
            :options="item.options"
            :value.sync="item.value"
            :disabled="true"
          />
          <BaseInput
            v-if="item.as === 'input' && item.key === 'password'"
            v-model="item.value"
            :rules="{
              password: true,
              required:
                isRequiredPassword('passwordConfirm') && item.value.length <= 0,
            }"
            :name="item.name"
            :vee-name="item.name"
            :type="item.type"
            autocomplete="new-password"
          />

          <BaseInput
            v-if="item.as === 'input' && item.key === 'password_2'"
            v-model="item.value"
            :rules="{
              password: true,
              required:
                isRequiredPassword('password') && item.value.length <= 0,
              confirmed: isComfirmedPassword(),
            }"
            :name="item.name"
            :vee-name="item.name"
            :type="item.type"
            autocomplete="new-password"
          />
          <BaseInput
            v-if="
              item.as === 'input' &&
                item.key !== 'password' &&
                item.key !== 'password_2'
            "
            v-model="item.value"
            :rules="{ ...item.rules, ...{ required: item.value.length <= 0 } }"
            :name="item.name"
            :vee-name="item.name"
            :type="item.type"
            disabled
            autocomplete="new-password"
          />
        </CCol>
      </CRow>
    </template>
  </BaseAddNewCard>
</template>

<style lang="scss" scoped>
.card-title {
  margin-bottom: 0 !important;
  font-weight: 600;
  color: #73818f;
}
</style>
